<script>
	import { projectSettings, acceptedFileUploadList } from "../../config";
	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../gtm";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let pageTitle = null;
	export let disabled = false;
	export let pageName = null;
	export let lastVisitedPage = null;

	let buttons = null;

	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	$model.documentList = $model.documentList || [];

	const handleSubmit = async (e) => {
		buttons.blockNext();

		await registerPageComplete(pageName);

		buttons.next();
		buttons.unblock();
	};
</script>

<PageSection>
	<Form {disabled} id="form-docs" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Supporting Documentation</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		{#if !disabled}
			<p>
				Please provide documentary evidence of your trading in James Hardie securities. Supporting documents may include
				holding statements, buy and sell contract notes, CHESS statements or broker account statements.
			</p>

			<FormRow>
				<FormColumn>
					<DropZone
						{options}
						{id}
						message="Drop files here or click to upload for this registration"
						bind:documentList={$model.documentList}></DropZone>
				</FormColumn>
			</FormRow>
		{:else}
			<div class="form-group">
				{#if $model.documentList && $model.documentList.length > 0}
					<table class="table table-sm">
						<tr>
							<th>Document Name</th>
						</tr>
						{#each $model.documentList as file}
							<tr>
								<td>{file.fileName}</td>
							</tr>
						{/each}
					</table>
				{:else}
					<p>No documents uploaded</p>
				{/if}
			</div>
		{/if}

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel="Next" />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>
